import type React from 'react';

import styles from './Loader.module.scss';

const Loader: React.FC = () => (
  <>
    <span className={styles.loader} />
    <span className={styles.loader} />
    <span className={styles.loader} />
    <span className={styles.loader} />
  </>
);

export default Loader;
